// Loginbtnvalidator.js
// Pure validation for Login. Returns all issues; does NOT notify itself.

export function runLoginValidation(getById) {
  const $ = getById || ((id) => document.getElementById(id));

  // Match IDs in Loginbox.jsx. The one identifier field takes a username,
  // an email, or a student login ID (contract §11) — the caller decides
  // which endpoint to hit from its shape.
  const values = {
    username: $('login-username')?.value?.trim() || '',
    password: $('login-password')?.value || '',
  };

  const errors = [];

  if (!values.username) errors.push('Username, email or student login ID: required.');
  if (!values.password) errors.push('Password: required.');

  if (errors.length) {
    return { ok: false, errors, values };
  }

  return { ok: true, errors: [], values };
}
